import { Injectable, Injector } from '@angular/core';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ClassifierService extends BaseApiService {
  baseUrl = '';

  get carmToken(): string {
    return this.getCarmToken();
  }

  constructor(protected injector: Injector) {
    super(injector);
    this.baseUrl = environment.business.default.baseUrl;
  }
}
